exports.components = {
  "component---src-lekoarts-gatsby-theme-styleguide-template-tsx": () => import("./../../../src/@lekoarts/gatsby-theme-styleguide/template.tsx" /* webpackChunkName: "component---src-lekoarts-gatsby-theme-styleguide-template-tsx" */),
  "component---src-template-tsx": () => import("./../../../src/template.tsx" /* webpackChunkName: "component---src-template-tsx" */)
}

